import { render, staticRenderFns } from "./BackToTop.vue?vue&type=template&id=7b8b9892&scoped=true"
import script from "./BackToTop.vue?vue&type=script&lang=js"
export * from "./BackToTop.vue?vue&type=script&lang=js"
import style0 from "./BackToTop.vue?vue&type=style&index=0&id=7b8b9892&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8b9892",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/chaoangoods.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b8b9892')) {
      api.createRecord('7b8b9892', component.options)
    } else {
      api.reload('7b8b9892', component.options)
    }
    module.hot.accept("./BackToTop.vue?vue&type=template&id=7b8b9892&scoped=true", function () {
      api.rerender('7b8b9892', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BackToTop/BackToTop.vue"
export default component.exports